import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  GameProgressDogFrozenImg,
  GameProgressDogImg,
  GameProgressStonesImg,
  ProgressTunnelImg
} from "@/assets"
import styles from "./ProgressTunnel.module.scss"
import { IProgressTunnel } from "./types"

export const ProgressTunnel: FC<IProgressTunnel> = ({
  progress,
  freezingMovements,
  block,
  side,
  tunnelWidth
}) => {
  const { t } = useTranslation()

  const dogSrc =
    freezingMovements > 0 ? GameProgressDogFrozenImg : GameProgressDogImg

  return (
    <div className={clsx(styles.ProgressTunnel, styles[side])}>
      <div
        className={styles.ProgressTunnel_content}
        style={{ width: tunnelWidth }}
      >
        <ProgressTunnelImg />
        <div className={styles.ProgressTunnel_items}>
          <div className={styles.ProgressTunnel_dog}>
            <img src={dogSrc} alt="dog" />
            <div
              className={clsx(
                styles.ProgressTunnel_badge,
                styles.ProgressTunnel_dog_progress
              )}
            >
              {progress}
              {t("meter_short")}
            </div>
          </div>

          {block > 0 && (
            <div className={styles.ProgressTunnel_stones}>
              <img
                className={styles.stones}
                src={GameProgressStonesImg}
                alt="stones"
              />
              <div
                className={clsx(
                  styles.ProgressTunnel_badge,
                  styles.ProgressTunnel_stones_progress
                )}
              >
                {block}
                {t("meter_short")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
